var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRiskPinLevel2 = function SvgRiskPinLevel2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 59,
    viewBox: "0 0 51 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4428 36.9594L34.8687 37.2212L34.4428 36.9594C30.4876 43.3933 26.4756 48.8406 26.3032 49.0747L26.2993 49.08L26.2977 49.0821L25.5001 50.1596L24.7025 49.0821L24.701 49.08L24.697 49.0747C24.5244 48.8403 20.5125 43.3931 16.5575 36.9594L16.137 37.2178L16.5574 36.9594C13.8062 32.4841 11.7409 28.6199 10.365 25.3869C8.98479 22.1439 8.31641 19.5772 8.31641 17.6838C8.31631 8.20952 16.025 0.5 25.5001 0.5C34.9752 0.5 42.6838 8.20952 42.6838 17.6838C42.6838 19.5772 42.0154 22.1439 40.6352 25.3869C39.2593 28.6199 37.194 32.4841 34.4428 36.9594Z",
    fill: "greenyellow"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4427 36.9594L34.8687 37.2212L34.4427 36.9594C30.4879 43.3928 26.4761 48.8398 26.3032 49.0746L26.2992 49.08L26.2977 49.0821L26 49.4842V0.507172C35.2448 0.772683 42.6838 8.37673 42.6838 17.6838C42.6838 19.5772 42.0154 22.1439 40.6352 25.3869C39.2592 28.6199 37.194 32.4841 34.4427 36.9594Z",
    fill: "greenyellow"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4,
    y: 0,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRiskPinLevel2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/riskPinLevel2.4143ccd5.svg";
export { ForwardRef as ReactComponent };